import { useMemo, useState } from 'react';
import canAutoplay from 'can-autoplay';
import sound from '../../../static/audio/notificationSound.mp3';

const useAudio = () => {
  const audio = useMemo(() => new Audio(sound), []);

  const [isPlaying, setIsPlaying] = useState(false);

  const playAudio = () => {
    if (!audio || !document.hidden) return;

    canAutoplay.audio().then(({result}) => {
      if (!result) return;

      audio.play();
      setIsPlaying(true);
    })
  };

  const stopAudio = () => {
    audio.pause();
    audio.currentTime = 0;
    setIsPlaying(false);
  };

  return {
    audio,
    isPlaying,
    playAudio,
    stopAudio,
  };
}

export default useAudio;
